module.exports = __webpack_public_path__ + "img/line5.06172639.png";